import React, { useState, useEffect } from "react";
import { Body } from "../../../components/text";
import { FloatingContent } from "../../../components/molecules/floatingContent";
import { Row as FormRow } from "../../../components/molecules/form/row";
import { Button } from "../../../components/atoms/form/button";
import { Textarea } from "../../../components/atoms/form/textarea";
import { Error } from "../../../components/atoms/form/error";
import { useForm } from "react-hook-form";
import Axios from "axios";
import { CheckboxWithLabel } from "../../../components/molecules/form/checkboxWithLabel";
import { useGetUser } from "../../../userStore";
import { Box } from "rebass";
import { analytics } from "MVVM/Analytics";
export function Report({
  setModalOpen,
  reportedUserId,
  reportedClipId,
  isProfile,
}) {
  let [state, setState] = useState({
    error: false,
    errorMsg: "",
    loading: false,
    complete: false,
  });
  let user = useGetUser();
  const TEXT_AREA_NAME = "additionalFeedback"; // this name is being specially handled in a few places
  useEffect(() => {
    analytics.track("Open Report Form");
  });
  const { handleSubmit, register, getValues, setValue } = useForm();
  const onSubmit = async (form) => {
    if (state.loading) {
      return;
    }

    const asArray = Object.entries(form);
    const filtered = asArray.filter(
      ([key, value]) => value === true || key === TEXT_AREA_NAME,
    );

    let category = filtered.filter((subArray) => {
      return subArray[1] === true;
    });

    if (category[0]) {
      category = category[0][0];
    } else {
      category = "OTHER";
    }
    let message = form[TEXT_AREA_NAME];

    setState({
      ...state,
      loading: true,
      error: false,
    });
    const opt = {
      method: "POST",
      url: `${process.env.REACT_APP_AWS_SERVERLESS}/users/reportuser`,
      data: {
        reporting: user._id,
        reported: reportedUserId,
        reportedClipId: reportedClipId,
        message: message,
        category: category,
      },
    };

    try {
      let response = await Axios(opt);
      if (response.status === 200) {
        setState({
          ...state,
          loading: false,
          error: false,
          complete: true,
        });
      }
    } catch (e) {
      setState({
        ...state,
        loading: false,
        error: true,
        errorMsg: e.response && e.response.data ? e.response.data.msg : "",
      });
    }
  };

  if (state.complete) {
    return <Thanks setModalOpen={setModalOpen} />;
  }

  function manageCheckboxes(e) {
    let values = Object.keys(getValues());
    for (const value of values) {
      //if its a checkbox and not the one we just clicked, set its value to false
      if (value !== e.target.name && value !== TEXT_AREA_NAME) {
        setValue(value, false);
      }
    }
  }
  return (
    <Box name="report-content-modal">
      {" "}
      <FloatingContent
        title="Report Profile"
        body={
          <Body>
            Help us understand the problem. What's the issue with this users
            profile?
          </Body>
        }
      >
        {" "}
        <form onSubmit={handleSubmit(onSubmit)}>
          <FormRow>
            <CheckboxWithLabel
              checkbox={{
                value: "AVATAR",
                id: "AVATAR",
                name: "AVATAR",
                ref: register("AVATAR", { required: false }),
              }}
              onClick={(e) => {
                manageCheckboxes(e);
              }}
            >
              Innappropriate profile image
            </CheckboxWithLabel>
          </FormRow>
          {isProfile ? (
            <></>
          ) : (
            <FormRow>
              <CheckboxWithLabel
                checkbox={{
                  value: "CLIP_TITLE",
                  id: "CLIP_TITLE",
                  name: "CLIP_TITLE",
                  ref: register("CLIP_TITLE", { required: false }),
                }}
                onClick={(e) => {
                  manageCheckboxes(e);
                }}
              >
                Innappropriate clip title
              </CheckboxWithLabel>
            </FormRow>
          )}

          <FormRow>
            {" "}
            <CheckboxWithLabel
              checkbox={{
                value: "IMPERSONATION",
                id: "IMPERSONATION",
                name: "IMPERSONATION",
                ref: register("IMPERSONATION", { required: false }),
              }}
              onClick={(e) => {
                manageCheckboxes(e);
              }}
            >
              Impersonation
            </CheckboxWithLabel>
          </FormRow>
          <FormRow>
            {" "}
            <CheckboxWithLabel
              checkbox={{
                value: "SPAM",
                id: "SPAM",
                name: "SPAM",
                ref: register("SPAM", { required: false }),
              }}
              onClick={(e) => {
                manageCheckboxes(e);
              }}
            >
              Spam
            </CheckboxWithLabel>
          </FormRow>
          <FormRow>
            {" "}
            <CheckboxWithLabel
              checkbox={{
                value: "OTHER",
                id: "OTHER",
                name: "OTHER",
                ref: register("OTHER", { required: false }),
              }}
              onClick={(e) => {
                manageCheckboxes(e);
              }}
              name="report-modal-other-checkbox"
            >
              Other
            </CheckboxWithLabel>
          </FormRow>
          <FormRow>
            <Textarea
              id={TEXT_AREA_NAME}
              name={TEXT_AREA_NAME}
              ref={register(TEXT_AREA_NAME, { required: false })}
            />
          </FormRow>

          {state.error && state.errorMsg ? (
            <Error>{state.errorMsg}</Error>
          ) : (
            <></>
          )}

          <Button
            disabled={state.loading}
            type="submit"
            name="report-modal-submit-button"
          >
            {state.loading ? "Submitting..." : "Submit"}
          </Button>
        </form>
      </FloatingContent>
    </Box>
  );
}

function Thanks({ setModalOpen }) {
  return (
    <Box name="report-modal-thanks">
      {" "}
      <FloatingContent
        title={
          <>
            Thanks!{" "}
            <span aria-label="thanks" role="img">
              🙌🏼
            </span>
          </>
        }
        body={
          <Body>Your feedback helps make Allstar awesome for everyone.</Body>
        }
      >
        <Button
          onClick={() => {
            setModalOpen(false);
          }}
        >
          Close
        </Button>
      </FloatingContent>
    </Box>
  );
}
